import React, { useContext, useEffect, useState } from 'react'
import { AddressChangeContext } from 'components/StraightThroughAddressComp/AddressContext/AddressChangeContext';
import Note from 'components/StraightThroughAddressComp/Note/Note';
import VehicleDA from 'components/StraightThroughVehicleComp/1_Vehicle/AddVehicleBody/6_DriverAssignment/VehicleDA_Main';
import { useLocation } from 'react-router-dom';
import HouseholdChangeBtnNav from '../HouseholdChangeBtnNav/HouseholdChangeBtnNav';
import { DriverHHMContext, DriverHHMContextComp, useDriverHHM } from '../HouseholdContext/DriverHHMContext';
import { HouseholdChangeContext } from '../HouseholdContext/HouseholdChangeContext';
import AddressChangeBtnNav from 'components/StraightThroughAddressComp/AddressChangeBtnNav/AddressChangeBtnNav';

const ChangeHousehold_DriverAssignment = () => {
    const addressChangeContext = useContext(AddressChangeContext)
    const householdChangeContext = useContext(HouseholdChangeContext)
    const driverHHMContext = useDriverHHM();
    const location = useLocation()
    const context = location.pathname.includes("address") ? AddressChangeContext : HouseholdChangeContext;
    const changeClass = location.pathname.includes("address") ? addressChangeContext?.addressChangeClass : householdChangeContext?.householdChangeClass;
    const endorsementType = location.pathname.includes("address") ? "AddressChange" : "HouseholdChange";
    const [isLargeScreen, setIsLargeScreen] = useState(false);

    // Update state based on window size
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 768) {
                setIsLargeScreen(true);
            } else {
                setIsLargeScreen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <DriverHHMContextComp>
            <div className='mx-2 mx-sm-5'>
                <VehicleDA requestContext={context} endorsementType={endorsementType} />
            </div>

            <hr />
            <Note />
            <hr />

            {/* Navigation Buttons */}
            {location.pathname.includes("address")
                ? <AddressChangeBtnNav />
                : <HouseholdChangeBtnNav />
            }
        </DriverHHMContextComp>
    )
}

export default ChangeHousehold_DriverAssignment